export default {
  translations: {
    CHANGE_PASSWORD_TITLE: "¡Cambiar contraseña!",
    CHANGE_PASSWORD_DESCRIPTION:
      "Para cambiar su contraseña, complete los campos a continuación:",
    CHANGE_PASSWORD_BAYER_TEXT:
      "Si tiene alguna pregunta o problema con la plataforma, comuníquese con nosotros por correo electrónico universomedico@bayer.com",
    PASSWORD_LABEL: "Defina su nueva contraseña",
    PASSWORD_CONFIRM_LABEL: "Confirme su nueva contraseña",
    PASSWORD_BUTTON_TEXT: "ESTABLECER NUEVA CONTRASEÑA",
    PASSWORD_ERROR_TEXT:
      "Su nueva contraseña DEBE contener: mínimo 1 número, mínimo 1 letra mayúscula, mínimo 8 caracteres, mínimo 1 letra minúscula, mínimo 1 carácter especial (ejemplos: @,!,#,*). Su nueva contraseña NO puede contener: más de tres carácteres iguales juntos",
    PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN: "Su nueva contraseña DEBE contener:",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER: "Mínimo 1 número",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER: "Mínimo 1 letra mayúscula",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH: "Mínimo 8 caracteres",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER: "Mínimo 1 letra minúscula",
    PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS: "Mínimo 1 carácter especial (Ejemplos: @,!,#,*)",
    PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN: "Su nueva contraseña NO puede contener:",
    PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS: "Más de tres carácteres iguales juntos",
    PASSWORD_DIFF: "¡Las contraseñas no coinciden!",
    PASSWORD_CHANGE_SUCCESS: "¡Contraseña cambiada exitosamente!",
    PASSWORD_CHANGE_SUCCESS_DESCRIPTION:
      "Ya puedes acceder al sitio web y a la aplicación de Universo Médico usando su nueva contraseña.",
    PASSWORD_CHANGE_ERROR_DESCRIPTION:
      "Desafortunadamente, su cambio de contraseña no se ha completado. Inténtalo de nuevo.",
    PASSWORD_CHANGE_ERROR: "¡Algo salió mal!",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/locales/es.js